import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { RouterModule } from '@angular/router';
import { AppTranslateModule } from '@core/app-translate.module';
import { WaiFormControlsModule } from '@feature/forms/form-controls/form-controls.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { BreadcrumbsModule } from '@shared/breadcrumbs/breadcrumbs.module';
import { DialogModule } from '@shared/dialog/dialog.module';
import { FilePickerModule } from '@shared/file-picker/file-picker.module';
import { NoAccessPanelModule } from '@shared/no-access-panel/no-access-panel.module';
import { DateModule } from '@shared/pipes/date/date.module';
// Temporarily removed for Angular 19 compatibility
// import { MaterialFileInputModule } from 'ngx-material-file-input';
import { DropzoneComponent, FileInputDirective } from '@ngx-dropzone/cdk';
import { MatDropzone } from '@ngx-dropzone/material';

import { PageHeaderModule } from './../page-header/page-header.module';
import { FileSizeModule } from './../pipes/file-size/file-size.module';
import { DataroomActionsService } from './dataroom-actions.service';
import { DataroomBrowserBreadcrumbsModule } from './dataroom-browser-breadcrumbs/dataroom-browser-breadcrumbs.module';
import { DataroomBrowserModule } from './dataroom-browser/dataroom-browser.module';
import { DataroomComponent } from './dataroom.component';
import { MoveDialogComponent } from './move-dialog/move-dialog.component';
import { NameDialogComponent } from './name-dialog/name-dialog.component';
import { UploaderComponent } from './uploader/uploader.component';
import { PreviewDialogComponent } from './preview-dialog/preview-dialog.component';
import { LoadingIndicatorModule } from '@shared/loading-indicator/loading-indicator.module';
import { UploadDialogComponent } from '@shared/dataroom/upload-dialog/upload-dialog.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { BulkDownloadBottomSheetComponent } from './bulk-download-bottom-sheet/bulk-download-bottom-sheet.component';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { NodeInfoDialogComponent } from './node-info-dialog/node-info-dialog.component';
import { PrimeNgModule } from '@shared/primeng.module';
import { SubscriptionModule } from '@shared/subscription/subscription.module';
import { FundNameDialogComponent } from './fund-name-dialog/fund-name-dialog.component';

export const imports: NgModule['imports'] = [
  BreadcrumbsModule,
  DataroomBrowserBreadcrumbsModule,
  DataroomBrowserModule,
  DateModule,
  DialogModule,
  FilePickerModule,
  FileSizeModule,
  FlexLayoutModule,
  FontAwesomeModule,
  MatButtonModule,
  MatCardModule,
  MatCheckboxModule,
  MatDialogModule,
  MatDividerModule,
  MatIconModule,
  MatListModule,
  MatMenuModule,
  MatPaginatorModule,
  MatProgressSpinnerModule,
  MatProgressBarModule,
  MatSortModule,
  MatTableModule,
  MatTooltipModule,
  MatSelectModule,
  // MaterialFileInputModule, // Temporarily removed for Angular 19 compatibility
  NoAccessPanelModule,
  PageHeaderModule,
  ReactiveFormsModule,
  WaiFormControlsModule,
  DropzoneComponent,
  FileInputDirective,
  MatDropzone,
];

@NgModule({
  declarations: [
    DataroomComponent,
    MoveDialogComponent,
    NameDialogComponent,
    UploaderComponent,
    PreviewDialogComponent,
    UploadDialogComponent,
    BulkDownloadBottomSheetComponent,
    NodeInfoDialogComponent,
    FundNameDialogComponent,
  ],
  imports: [
    ...imports,
    CommonModule,
    FormsModule,
    RouterModule,
    AppTranslateModule,
    LoadingIndicatorModule,
    MatFormFieldModule,
    MatInputModule,
    MatBottomSheetModule,
    PrimeNgModule,
    SubscriptionModule,
  ],

  providers: [DataroomActionsService],
  exports: [DataroomComponent, UploaderComponent, FundNameDialogComponent],
})
export class DataroomModule {}
